"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createId = void 0;
var defaultCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function createId(params) {
    var _a = Object.assign({
        characters: defaultCharacters
    }, params), characters = _a.characters, length = _a.length;
    return new Array(length).map(function () {
        return characters[Math.floor(Math.random() * characters.length)];
    }).join("");
}
exports.createId = createId;
